import axios from "axios";
import {getSignParams, getConfig} from "../utils";
import configEnv from "./config"
let splitTimestamp = 0
getConfig()
const service = axios.create({
    baseURL: process.env.VUE_APP_KIOSK_BASE_API,
    timeout: 5000,
    withCredentials: true,
});
service.interceptors.request.use(
    (config) => {
        const apiVersion =
            config.version === 'v4'
                ? process.env.VUE_APP_API_VERSION_V4
                : process.env.VUE_APP_API_VERSION_V1;
        let ak = process.env.VUE_APP_KIOSK_AK;
        let sk = process.env.VUE_APP_KIOSK_SK;
        const sign = getSignParams(config.url, {
            ak,
            sk,
            version: apiVersion,
            "api-version": apiVersion,
            split_timestamp: splitTimestamp
        });
        config.headers = {
            "Content-Type": "application/json",
            timestamp: sign.timestamp,
            appKey: sign.appKey,
            sign: sign.sign,
            version: sign.version,
            "api-version": apiVersion,
            "brandMdCode": configEnv.env.VUE_APP_BRAND == "COTTI" ? 20200000006 : 20200000007,
            split_timestamp: splitTimestamp,
        };
        const token = sessionStorage.getItem('COTTI_USER_TOKEN')
        if( token ) {
            config.headers.token = token
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

service.interceptors.response.use(
    (response) => {
        if (response.headers?.split_timestamp && Number(response.headers?.split_timestamp) > Number(splitTimestamp)) {
            splitTimestamp = response.headers.split_timestamp
          }
        return response.data;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default service;
